import axios from "axios";
import { BASE_URL, ENDPOINTS } from "./_config";


export const getClinicInfoById = async (clinicInfoId) => {
    try {
      const response = await axios.get(`${ENDPOINTS.CLINIC.GET_CLINIC_BY_ID}`, {
        params: { clinicInfoId }        
      });
      return response.data; // Return the clinic data
    } catch (error) {
      console.error('Error fetching clinic information:', error);
      throw error; // Propagate the error
    }
  };
  